import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router";
import DiagnosticsCenter from "./DiagnosticsCenter";
import DiagnosticsPatternDetail from "./DiagnosticsPatternDetails";
import InterpretationThemes from "./InterpretationThemes";
import InterpretationThemeDetails from "./InterpretationThemeDetails";
import Login from "./Login";
import AuthProvider from "./components/AuthProvider";
import InterpretationThemeAdd from "./InterpretationThemeAdd";
import ConfigurationCenter from "./ConfigurationCenter";
import Landing from "./Landing";
import ProtectedRoute from "./components/ProtectedRoute";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          
          {/* Protected routes */}
          <Route path="/app" element={<ProtectedRoute><App /></ProtectedRoute>} />
          <Route path="/diagnostics-center" element={<ProtectedRoute><DiagnosticsCenter /></ProtectedRoute>} />
          <Route
            path="/diagnostics-center/patterns/:patternId"
            element={<ProtectedRoute><DiagnosticsPatternDetail /></ProtectedRoute>}
          />
          <Route
            path="/configuration"
            element={<ProtectedRoute><ConfigurationCenter /></ProtectedRoute>}
          />
          <Route
            path="/interpretation-themes/add"
            element={<ProtectedRoute><InterpretationThemeAdd /></ProtectedRoute>}
          />
          <Route
            path="/interpretation-themes/associate/:patternId"
            element={<ProtectedRoute><InterpretationThemes /></ProtectedRoute>}
          />
          <Route
            path="/interpretation-themes/themes/:interpretationThemeId"
            element={<ProtectedRoute><InterpretationThemeDetails /></ProtectedRoute>}
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
